import { Divider, IconButton } from "@mui/material/node";
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import * as React from 'react';
import { NewNodeDialog } from '../../Dialogs/newNodeDialog';
import { useState, useContext } from 'react';
import { ProjectContext } from '../../../contexts/ProjectContext';
import { DeleteElementDialog } from "../../Dialogs/deleteElementDialog";
import { HelpOutline } from "@mui/icons-material";
import { useTheme } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';

export const MoreButton = (props) => {

    const [showNewNodeDialog, setShowNewNodeDialog] = useState(false);
    const [showDeleteNodeDialog, setShowDeleteNodeDialog] = useState(false);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [newNodeType, setNewNodeType] = useState("O");
    const theme = useTheme();
    const { startConnection, deleteElement } = useContext(ProjectContext);


    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleHelp = () => {
        window.open("https://www.google.com", "_blank", "noopener,noreferrer");
        setAnchorElUser(null);
    };

    const handleAddNode = () => {
        setNewNodeType("O");
        setShowNewNodeDialog(true)
        setAnchorElUser(null);
    };

    const handleAddParentNode = () => {
        setNewNodeType("PARENT");
        setShowNewNodeDialog(true)
        setAnchorElUser(null);
    };

    const handleAddConnection = () => {
        startConnection()
        setAnchorElUser(null);
    };

    const handleDeleteElement = () => {
        setAnchorElUser(null);
        setShowDeleteNodeDialog(true);
    }

    if (!props.selectedItem || props.selectedItem === -1) {
        return (
            <>
                <IconButton aria-label="Refresh layout" onClick={handleOpenUserMenu} color="inherit" sx={{ m: 0.5, color: theme.palette.menuIcon.main }}>
                    <Tooltip title="Show more">
                        <MoreVertIcon />
                    </Tooltip>
                </IconButton>
                <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                >
                    {props.isMobile &&
                        <MenuItem key="menuItemMobileResetLayout" onClick={props.actionResetLayout}>
                            <Typography textAlign="center">Reset Layout</Typography>
                        </MenuItem>
                    }
                    {props.isMobile &&
                        <MenuItem key="menuItemMobileFitToScreen" onClick={props.actionFitToScreen}>
                            <Typography textAlign="center">Fit to Screen</Typography>
                        </MenuItem>
                    }
                    <MenuItem key="help" onClick={handleHelp}>
                        <ListItemIcon>
                            <HelpOutline />
                        </ListItemIcon>
                        <Typography textAlign="center">Help</Typography>
                    </MenuItem>
                </Menu>
            </>
        );
    }

    if (props.selectedItem) {
        return (
            <>
                <IconButton aria-label="Refresh layout" onClick={handleOpenUserMenu} color="inherit" sx={{ m: 0.5, color: theme.palette.menuIcon.main }}>
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                >
                    {/* <MenuItem key="myprojects" onClick={handleAddParentNode}>
                        <Typography textAlign="center">Add node</Typography>
                    </MenuItem>
                    <MenuItem key="profile" onClick={handleAddConnection}>
                        <Typography textAlign="center">Add Connection</Typography>
                    </MenuItem> */}

                    <MenuItem key="logout" onClick={handleDeleteElement}>
                    <ListItemIcon>
                            <DeleteIcon />
                        </ListItemIcon>
                        <Typography textAlign="center">Delete</Typography>
                    </MenuItem>

                    {props.isMobile &&
                        <Divider />
                    }
                    {props.isMobile &&
                        <MenuItem key="menuItemResetLayout" onClick={props.actionResetLayout}>
                            <Typography textAlign="center">Reset Layout</Typography>
                        </MenuItem>
                    }
                    {props.isMobile &&
                        <MenuItem key="menuItemFitToScreen" onClick={props.actionFitToScreen}>
                            <Typography textAlign="center">Fit to Screen</Typography>
                        </MenuItem>
                    }
                    <MenuItem key="help" onClick={handleHelp}>
                        <ListItemIcon>
                            <HelpOutline />
                        </ListItemIcon>
                        <Typography textAlign="center">Help</Typography>
                    </MenuItem>
                </Menu>
                <DeleteElementDialog open={showDeleteNodeDialog} handleClose={() => setShowDeleteNodeDialog(false)} refreshLayout={() => props.canvasRef.current.setLayout()} />
            </>
        );
    }
}
